// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import BasketItemModel from '../../model/basket-item-model';
import BasketItemDTO from '../dto/basket-item-dto';
import dtoSchema from '../schemas/basket-item-schema';

export default abstract class BasketItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<BasketItemDTO>) {
    super();
    if (data) {
      this.itemNumber = data.itemNumber;
      this.itemPriceNumber = data.itemPriceNumber;
      this.itemPriceType = data.itemPriceType;
      this.type = data.type ?? undefined;
      this.caption = data.caption ?? undefined;
      this.quantity = data.quantity;
      this.currency = data.currency ?? undefined;
      this.unitPrice = data.unitPrice;
      this.grossPrice = data.grossPrice;
      this.vatRate = data.vatRate;
      this.vatIncluded = data.vatIncluded;
      this.netAmount = data.netAmount;
      this.vatAmount = data.vatAmount;
      this.promotionCode = data.promotionCode ?? undefined;
    }
  }
  /**
  * @type {int32}
  */
  itemNumber?: number;
  /**
  * @type {int32}
  */
  itemPriceNumber?: number;
  /**
  * @type {int32}
  */
  itemPriceType?: number;
  /**
  */
  type?: string;
  /**
  */
  caption?: string;
  /**
  * @type {double}
  */
  quantity?: number;
  /**
  */
  currency?: string;
  /**
  * @type {double}
  */
  unitPrice?: number;
  /**
  * @type {double}
  */
  grossPrice?: number;
  /**
  * @type {double}
  */
  vatRate?: number;
  /**
  */
  vatIncluded?: boolean;
  /**
  * @type {double}
  */
  netAmount?: number;
  /**
  * @readonly
  * @type {double}
  */
  vatAmount?: number;
  /**
  */
  promotionCode?: string;

  static toModel(dto: DeepPartial<BasketItemDTO>): BasketItemModel;
  static toModel(dto: DeepPartial<BasketItemDTO> | undefined | null): BasketItemModel | undefined;
  static toModel(dto: DeepPartial<BasketItemDTO> | undefined | null): BasketItemModel | undefined {
    return dto ? new BasketItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<BasketItemModel> | BasketItemModel): BasketItemDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      itemNumber: unwrapped.itemNumber,
      itemPriceNumber: unwrapped.itemPriceNumber,
      itemPriceType: unwrapped.itemPriceType,
      type: unwrapped.type,
      caption: unwrapped.caption,
      quantity: unwrapped.quantity,
      currency: unwrapped.currency,
      unitPrice: unwrapped.unitPrice,
      grossPrice: unwrapped.grossPrice,
      vatRate: unwrapped.vatRate,
      vatIncluded: unwrapped.vatIncluded,
      netAmount: unwrapped.netAmount,
      vatAmount: unwrapped.vatAmount,
      promotionCode: unwrapped.promotionCode,
    } as BasketItemDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for BasketItemModel, can not map to BasketItemDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
